module.exports = __webpack_public_path__ + "media/components/src/assets/images/decor/right_decor-a3cc5e90ea63bacbf9cfdfa4a6cc0bf6.svg";